<!-- controls：向用户显示播放按钮控件 -->
<template>
  <video ref="video" :poster="item.videoImg" controls class="video-js vjs-default-skin vjs-big-play-centered">
    <source :src="item.path" />
  </video>
</template>

<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.min.css'

export default {
  name: 'Video',
  props: ['item'],
  data() {
    return {
      player: null, // 用来存储当前 video
    }
  },
  mounted() {
    // 渲染视频
    this.player = videojs(this.$refs.video)
  },
}
</script>
